import { gql } from "@apollo/client";

export default gql`
  fragment AssetPortfolioPositionFields on AssetPortfolioPosition {
    _id
    tickerSymbol
    numberOfShares
    price {
      adjustedClose
      date
    }
    goal
    security {
      _id
      type
      tickerSymbol
      name
      issuer {
        ... on AmericanCompanyIssuer {
          _id
          name
          tickerSymbols
          sector
          isREIT
        }
        ... on BrazilianCompanyIssuer {
          _id
          name
          tickerSymbolPrefix
          sector
          cnpj
          bookkeeper
        }
        ... on BrazilianRealEstateFundIssuer {
          _id
          name
          tickerSymbolPrefix
          sector
          cnpj
        }
      }
    }
  }
`;
